module.exports = __webpack_public_path__ + "static/media/v.c824d70e.mp4";